import { createEntityAdapter, createSelector } from "@reduxjs/toolkit";
import { apiSlice } from "../apiSlice";

// Create an adapter for the cancellations list
const cancellationsListAdapter = createEntityAdapter({
  selectId: (cancellation) => cancellation.id,
});

const initialState = cancellationsListAdapter.getInitialState();

// Define the slice (ONLY QUERIES)
export const cancellationsListSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Fetch list of cancellations
    getCancellationsList: builder.query({
      query: (filters = {}) => {
        const params = [];
        if (filters.status) params.push(`status=${filters.status}`);
        if (filters.search)
          params.push(`search=${encodeURIComponent(filters.search)}`);

        return params.length
          ? `cancellations?${params.join("&")}`
          : "cancellations";
      },
      transformResponse: (responseData) => {
        const loadedCancellationsList = responseData.data.map((item) => ({
          ...item,
        }));

        return cancellationsListAdapter.setAll(
          initialState,
          loadedCancellationsList
        );
      },
      providesTags: (result) =>
        result
          ? [
              { type: "cancellations", id: "cancellationsList" },
              ...result.ids.map((id) => ({
                type: "cancellations",
                id,
              })),
            ]
          : [{ type: "cancellations", id: "cancellationsList" }],
    }),

    // ✅ Fetch individual cancellation details
    getCancellationById: builder.query({
      query: (cancellationId) => `cancellations/${cancellationId}`,
      transformResponse: (responseData) => responseData.data,
      providesTags: (result, error, cancellationId) => [
        { type: "cancellations", id: cancellationId },
      ],
    }),
  }),
});

// Export hooks
export const {
  useGetCancellationsListQuery,
  useGetCancellationByIdQuery,
} = cancellationsListSlice;

/* ---------------- SELECTORS ---------------- */

const cancellationFilter = (state) => state.cancellationFilter;

const selectCancellationListResult = createSelector(
  [cancellationFilter, (state) => state],
  (filter, state) =>
    cancellationsListSlice.endpoints.getCancellationsList.select({
      status: filter.status,
      search: filter.search,
    })(state)
);

const selectCancellationsListData = createSelector(
  [selectCancellationListResult],
  (result) => result?.data ?? initialState
);

export const {
  selectAll: selectCancellations,
  selectById: selectCancellationById,
  selectIds: selectCancellationIds,
} = cancellationsListAdapter.getSelectors((state) =>
  selectCancellationsListData(state)
);
